import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const BannerFive = () => {
  const { t, i18n } = useTranslation();
  const bullets = t('hero.bullets', { returnObjects: true });
  const metrics = t('hero.metrics', { returnObjects: true });
  const dir = i18n.dir();

  return (
    <section id="home" className="section section-padding mutawir-hero">
      <div className="container">
        <div className={`row align-items-center g-5 ${dir === 'rtl' ? 'flex-row-reverse' : ''}`}>
          <div className="col-lg-6">
          <div className="mutawir-hero__content">
            <h1 className="mutawir-hero__title">
              <Trans i18nKey="hero.title" components={{ highlight: <span className="mutawir-highlight" /> }} />
            </h1>
              <p className="mutawir-hero__description">{t('hero.description')}</p>
              <div className="mutawir-hero__actions">
                <a className="axil-btn btn-fill-primary" href="#contact">
                  {t('hero.primaryCta')}
                </a>
                <a className="axil-btn btn-borderd" href="#services">
                  {t('hero.secondaryCta')}
                </a>
              </div>
              {Array.isArray(bullets) && bullets.length > 0 && (
                <ul className="mutawir-hero__bullets">
                  {bullets.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="col-lg-5 ms-lg-auto">
            <div className="mutawir-hero__metrics">
              {Array.isArray(metrics) && metrics.map((metric, index) => (
                <div className="mutawir-metric" key={index}>
                  <span className="mutawir-metric__value">{metric.value}</span>
                  <span className="mutawir-metric__label">{metric.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerFive;
